import { render, staticRenderFns } from "./MyMenuDropzoneInput.vue?vue&type=template&id=4c5e0266&"
import script from "./MyMenuDropzoneInput.vue?vue&type=script&lang=js&"
export * from "./MyMenuDropzoneInput.vue?vue&type=script&lang=js&"
import style0 from "./MyMenuDropzoneInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports